import { render } from "./generic.vue?vue&type=template&id=912258f0&scoped=true"
import script from "./generic.vue?vue&type=script&lang=js"
export * from "./generic.vue?vue&type=script&lang=js"

import "./generic.vue?vue&type=style&index=0&id=912258f0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-912258f0"]])

export default __exports__